import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import TheTeam from "../components/Team/TheTeam.jsx";

const Team = () => {
  return (
    <div className="font-inter text-white bg-bg-primary flex flex-col">
      <div className="px-8 font-inter text-white overflow-x-hidden xl:px-20 2xl:px-60 flex flex-col">
        <NavBar />
        <p className="italic text-5xl font-bold">MEET THE TEAM</p>
        <TheTeam />
      </div>
      <Footer link="Team" />
    </div>
  );
};
export default Team;
